<script>
import { page } from '$app/state'

let menuOpen = $state(false)

/** @param {string} pathname */
function studiesActive(pathname) {
  return (
    pathname.startsWith('/studies') ||
    pathname.startsWith('/glp1') ||
    pathname.startsWith('/adc-oncology')
  )
}

function closeMenu() {
  menuOpen = false
}

function toggleMenu() {
  menuOpen = !menuOpen
}

/** @param {MouseEvent} e */
function scrollToFaq(e) {
  closeMenu()
  if (page.url.pathname === '/') {
    e.preventDefault()
    setTimeout(() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' }), 50)
  }
}
</script>

<div
  data-animation="default"
  class="nav w-nav"
  data-easing2="ease"
  fs-scrolldisable-element="smart-nav"
  data-easing="ease"
  data-collapse="medium"
  data-w-id="abad23f6-3206-d95e-518e-2548f4c46996"
  role="banner"
  data-duration="400"
>
  <div class="nav-container">
    <div class="logo-wrapper">
      <a
        href="/"
        class="logo w-nav-brand"
        aria-current={page.url.pathname === '/' ? 'page' : undefined}
      >
        <img
          src="/webflow/images/logo-v2-wht.svg"
          loading="lazy"
          width="134"
          height="40"
          alt="IMX Data"
        />
      </a>
      <nav
        id="w-node-abad23f6-3206-d95e-518e-2548f4c4699b-f4c46996"
        class="nav-menu w-nav-menu"
        data-nav-menu-open={menuOpen ? '' : undefined}
      >
        <a
          href="/products"
          class="nav-link"
          onclick={closeMenu}
          aria-current={page.url.pathname === '/products' ? 'page' : undefined}>Products</a
        >
        <a
          href="/studies"
          class="nav-link"
          onclick={closeMenu}
          aria-current={studiesActive(page.url.pathname) ? 'page' : undefined}>Case Studies</a
        >
        <a href="/#faq" class="nav-link" onclick={scrollToFaq}>FAQ</a>
        <a
          href="/careers"
          class="nav-link"
          onclick={closeMenu}
          aria-current={page.url.pathname === '/careers' ? 'page' : undefined}>Careers</a
        >
        <a
          href="/contact"
          class="nav-link"
          onclick={closeMenu}
          aria-current={page.url.pathname === '/contact' ? 'page' : undefined}>Contact</a
        >
      </nav>
    </div>
    <div id="w-node-abad23f6-3206-d95e-518e-2548f4c469b0-f4c46996" class="actions-wrapper">
      <div
        class="nav-menu-button"
        class:w--open={menuOpen}
        aria-expanded={String(menuOpen)}
        role="button"
        tabindex="0"
        onclick={toggleMenu}
      >
        <div class="menu-icon">
          <div class="menu-icon-line-top"></div>
          <div class="menu-icon-line-bottom"></div>
        </div>
      </div>
    </div>
  </div>
</div>
